// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__wLUOK","padding":"panel_padding__yzFrO","numberContainer":"panel_numberContainer__0fc0C","number":"panel_number__Gvl95","content":"panel_content__bTnSs"};